import { z } from "@/zod";

export const FILE_TYPE_PHOTO = "photo";
export const FILE_TYPE_MOVIE = "movie";
export const FILE_TYPE_DOCUMENT = "document";

export const FILE_TYPE = [
  FILE_TYPE_PHOTO,
  FILE_TYPE_MOVIE,
  FILE_TYPE_DOCUMENT,
] as const;

export default z.enum(FILE_TYPE);
